module.exports = __webpack_public_path__ + "img/Facebook.098f7725.png";